import {
	ApolloClient,
	createHttpLink,
	DefaultOptions,
	InMemoryCache, split,
} from "@apollo/client";
import {setContext} from "@apollo/client/link/context";
import {GlobalState} from "../global/GlobalState";
import {Configuration} from "../global/Configuration";
import {GraphQLWsLink} from "@apollo/client/link/subscriptions";
import {createClient} from "graphql-ws";
import {getMainDefinition} from "@apollo/client/utilities";

function createApolloClient(
	uri: string,
	wsurl?: string,
	options?: DefaultOptions,
	addTypename = true
): ApolloClient<any> {
	const httpLink = createHttpLink({
		uri: uri,
	});
	
	function authHeaders() {
		return {
			"X-Id-Token": `${GlobalState.userSessionRequired.tokenType} ${GlobalState.userSessionRequired.idToken}`,
			Authorization: `${GlobalState.userSessionRequired.tokenType} ${GlobalState.userSessionRequired.accessToken}`,
		};
	}
	
	const wsLink = new GraphQLWsLink(createClient({
		url: wsurl ?? "",
		keepAlive: 10000,
		connectionParams: () => (authHeaders())
	}));
	
	const authLink = setContext((_, {headers}) => {
		return {
			headers: {
				...headers,
				...authHeaders()
			},
		};
	});
	
	const splitLink = split(
		({query}) => {
			const definition = getMainDefinition(query);
			return (
				definition.kind === "OperationDefinition" &&
				definition.operation === "subscription"
			);
		},
		wsLink,
		authLink.concat(httpLink),
	);
	return new ApolloClient<any>({
		link: splitLink,
		cache: new InMemoryCache({addTypename: addTypename}),
		defaultOptions: options,
	});
}

class GraphQLServices {
	readonly authorizationClient = createApolloClient(
		`${Configuration.kiziBackendHost}/authorization/graphql`
	);
	readonly orderClient = createApolloClient(
		`${Configuration.kiziBackendHost}/order/api/reader/graphql`
	);
	
	readonly orderInputClient = createApolloClient(
		`${Configuration.kiziBackendHost}/order/graphql`
	);
	readonly dynamicFormsClient = createApolloClient(
		`${Configuration.kiziBackendHost}/dynamicforms/graphql`
	);
	readonly travelClient = createApolloClient(
		`${Configuration.kiziBackendHost}/travel/multi-trip/graphql`
	);
	readonly healthCare = createApolloClient(
		`${Configuration.kiziBackendHost}/healthcare/graphql`
	);
	readonly homeContentPackage = createApolloClient(
		`${Configuration.kiziBackendHost}/home-content-package/graphql`
	);
	readonly savings = createApolloClient(
		`${Configuration.kiziBackendHost}/savings/graphql`
	);
	readonly triplePlay = createApolloClient(
		`${Configuration.kiziBackendHost}/triple-play-v2/graphql`
	);
	readonly productsClient = createApolloClient(
		`${Configuration.kiziBackendHost}/product/graphql`
	);
	readonly energyAuctionClient = createApolloClient(
		`${Configuration.kiziBackendHost}/energy-auction/graphql`
	);
	readonly comparatorIntakesClient = createApolloClient(
		`${Configuration.kiziBackendHost}/comparator-intakes/graphql`
	);
	readonly mailexClient = createApolloClient(
		`${Configuration.kiziBackendHost}/surebase/messaging/email/graphql`
	);
	readonly documentsClient = createApolloClient(
		`${Configuration.surebaseBackendHost}/surebase-documents/graphql`,
		`${Configuration.kiziSubscriptionUrl}?module=surebase-documents`,
		{
			query: {
				fetchPolicy: "no-cache",
			},
		},
		false
	);
	
	readonly querytoolClient = createApolloClient(
		`${Configuration.riskBackendHost}/AnvaQueryTool/graphql`,
		"",
		{
			query: {
				fetchPolicy: "no-cache",
			},
		}
	);
	
	readonly translationsClient = createApolloClient(
		`${Configuration.kiziBackendHost}/translations/graphql`
	);
}

export const graphQLServices = new GraphQLServices();
